import './DefaultLayout.scss'
import AppHeader from "../../components/AppHeader/AppHeader"

const DefaultLayout = ({ children }) => {
	return (
		<div className="default-layout">
			<AppHeader />
			<div className="default-layout__ps">
				<main className='h-full'>
					{children}
				</main>
			</div>
		</div>
	)
}

export default DefaultLayout